exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ImageSwiper-module__container--2ugQa {\r\n  width: 100%;\r\n  height: 294px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.ImageSwiper-module__swipe--1olnF{\r\n  width: 100%;\r\n  height: 256px;\r\n}\r\n\r\n.ImageSwiper-module__dotContainer--WFF-o{\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin-top: 12px;\r\n}\r\n\r\n.ImageSwiper-module__swiperNavigationActiveDot--23UAo{\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 3px;\r\n  margin: 4px;\r\n  background-color: #aaaaaa;\r\n}\r\n\r\n.ImageSwiper-module__swiperNavigationDot--2-lSz{\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 3px;\r\n  margin: 4px;\r\n  background-color: #dddddd;\r\n}", ""]);

// exports
exports.locals = {
	"container": "ImageSwiper-module__container--2ugQa",
	"swipe": "ImageSwiper-module__swipe--1olnF",
	"dotContainer": "ImageSwiper-module__dotContainer--WFF-o",
	"swiperNavigationActiveDot": "ImageSwiper-module__swiperNavigationActiveDot--23UAo",
	"swiperNavigationDot": "ImageSwiper-module__swiperNavigationDot--2-lSz"
};